export default __webpack_public_path__ + "static/media/croatia.af43d770.svg";